import { BehaviorSubject } from 'rxjs';

export class AppSession {
    static streamLightsData = new BehaviorSubject(null);

    static closeAll() {
        AppSession.streamLightsData.complete();
    }
}